import { render, staticRenderFns } from "./AutoPostBoostingAd.vue?vue&type=template&id=924738fa&scoped=true&"
import script from "./AutoPostBoostingAd.vue?vue&type=script&lang=ts&"
export * from "./AutoPostBoostingAd.vue?vue&type=script&lang=ts&"
import style0 from "./AutoPostBoostingAd.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AutoPostBoostingAd.vue?vue&type=style&index=1&id=924738fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924738fa",
  null
  
)

export default component.exports